module.exports = __webpack_public_path__ + "static/media/vanCar.0da6057b.jpg";